import { z } from 'zod';

export const planEditSchema = z.object({
  name: z
    .string()
    .min(1, 'プラン名を入力してください')
    .max(255, '255文字以内で入力してください'),
  amount: z
    .string()
    .min(1, '金額を入力してください')
    .refine((val) => /^[0-9]+$/.test(val), {
      message: '半角数字で入力してください',
    })
    .refine(
      (val) => {
        const n = Number(val);
        return Number.isInteger(n) && n >= 0;
      },
      {
        message: '0以上の整数を入力してください',
      },
    ),
  promotion_code: z
    .union([
      z.string().max(255, 'クーポンコードは255文字以内で入力してください'),
      z.null(),
    ])
    .optional(),
  is_auto_coupon_prefill: z.boolean().optional(),
  trial_days: z
    .string()
    .optional()
    .refine((val) => /^[0-9]+$/.test(val), {
      message: '半角数字で入力してください',
    })
    .refine(
      (val) => {
        const n = Number(val);
        return Number.isInteger(n) && n >= 0;
      },
      { message: '0以上の整数を入力してください' },
    ),
});
